<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $tc('kiosk.title', 2) }}</h1>
    </div>
    <div class="details-component__content content" v-if="kiosks">
      <v-client-table :data="kiosks" :columns="columns" :options="options"></v-client-table>
    </div>
  </div>
</template>

<script>
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';

export default {
  props: ['kiosks', 'tenant'],
  components: {
    ConfirmationModal,
    WarningModal,
  },
  computed: mapGetters({
    user: 'user/user/user',
  }),
  methods: {
    remove() {
      this.showConfirmationModal = false;
      this.$store.dispatch('kiosks/kiosk/delete', { id: this.removeKiosk.id, user: this.user })
        .then(() => {
          if (!this.kioskError) {
            this.$store.commit(`tenants/tenant/${mTypes.REMOVE_KIOSK}`, this.removeKiosk.id);
          } else {
            this.warningHeader = this.$t('accounts.removing_error_header'); // todo
            this.warningBody = this.$t('accounts.removing_error'); // todo
            this.showWarningModal = true;
          }
          this.removeKiosk = {};
        });
    },
    closeWarningModal() {
      this.showWarningModal = false;
    },
    showConfirmation(kiosk) {
      this.removeKiosk = kiosk;
      this.showConfirmationModal = true;
    },
    cancel() {
      this.showConfirmationModal = false;
    },
    edit(kiosk) {
      this.$router.push({ name: 'edit-kiosk', params: { id: kiosk.id } });
    },
    showHashInfo(kiosk) {
      const title = kiosk.hash_enabled ?
        this.$t('kiosk.hashIsEnabled') :
        this.$t('kiosk.hashIsDisabled');

      const content = kiosk.hash_enabled ?
        `${process.env.BASE_URL}kiosk/?hash=${kiosk.kiosk_hash}` :
        '';

      this.$alert(content, title, {
        confirmButtonText: 'OK',
      });
    },
  },
  data() {
    return {
      showConfirmationModal: false,
      showWarningModal: false,
      warningBody: null,
      warningHeader: null,
      removeKiosk: {},
      form: {},
      columns: ['description', 'pin', 'kiosk_hash', 'created_at'],
      options: {
        rowClassCallback: () => 'VueTables__row',
        filterable: false,
        headings: {
          name: () => this.$t('kiosk.description'),
          pin: () => this.$t('kiosk.pin'),
          kiosk_hash: () => this.$t('kiosk.hash'),
          created_at: () => this.$t('common.created_at'),
        },
        texts: {
          noResults: this.$t('tables.noRecords'),
          count: this.$t('tables.count'),
        },
        templates: {
          kiosk_hash: (h, row) => (
            <div class="hash-button-wrapper">
              <a on-click={ () => this.showHashInfo(row) } id={row.id}>
                { this.$t('kiosk.link') }
              </a>
            </div>
          ),
        },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
@import '~styles/blocks/details.scss';
</style>



// WEBPACK FOOTER //
// src/components/products/KiosksTable.vue